import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { string } = proptypes;

const Address = ({
  companyName, addressLine1, addressLine2, city, state, zipCode, formatedPhoneNumber
}) => {

  const cityInfo = city ? `${city},` : undefined;
  return (
    <div className="sui-mt-2">
      {companyName && (<Typography variant="body-lg">{companyName}</Typography>)}
      {addressLine1 && (<Typography variant="body-lg">{addressLine1}</Typography>)}
      {addressLine2 && (<Typography variant="body-lg">{addressLine2}</Typography>)}
      {(city || state || zipCode) && (<Typography variant="body-lg">{cityInfo} {state} {zipCode}</Typography>)}
      {formatedPhoneNumber && (<Typography variant="body-lg">{formatedPhoneNumber}</Typography>)}
    </div>
  );

};

Address.propTypes = {
  addressLine1: string,
  companyName: string,
  addressLine2: string,
  city: string,
  state: string,
  zipCode: string,
  formatedPhoneNumber: string,
};

Address.defaultProps = {
  addressLine1: null,
  addressLine2: null,
  companyName: null,
  city: null,
  state: null,
  zipCode: null,
  formatedPhoneNumber: null,
};

export { Address };